import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpRequestHandler } from '../../models/http-model';
const HEADERS = {};

@Injectable()
export class TaskSchedulerService {

    static ENV = environment;
    constructor(private httpService: HttpService) {
    }

    public saveTaskScheduler(data: any, httpRequesthandler: HttpRequestHandler): void {
        httpRequesthandler.headers = HEADERS;
        this.httpService.post(TaskSchedulerService.ENV.environment.API.save_task_scheduler, data, httpRequesthandler);
    }
   
    public getTaskScheduler( connector = null, httpRequesthandler: HttpRequestHandler): void {
        let url = TaskSchedulerService.ENV.environment.API.save_task_scheduler;
        if(connector)
            url = `${url}?connector=${connector}`;

        httpRequesthandler.headers = HEADERS;
        this.httpService.get(url, httpRequesthandler);
    }
    public deleteTaskScheduler( data: any, httpRequesthandler: HttpRequestHandler): void {
        httpRequesthandler.headers = HEADERS;
        const param = {id: data.id, comentario: data.comentario}
        this.httpService.post(TaskSchedulerService.ENV.environment.API.remove_task_scheduler, param, httpRequesthandler);
    }

    public getEmailsUser(conector, httpRequesthandler: HttpRequestHandler): void {
        httpRequesthandler.headers = HEADERS;
        this.httpService.get(`${TaskSchedulerService.ENV.environment.API.schedule_create_email}/${conector}`, httpRequesthandler);
    }
    public getScheduleApp( httpRequesthandler: HttpRequestHandler): void {
        httpRequesthandler.headers = HEADERS;
        this.httpService.get(TaskSchedulerService.ENV.environment.API.schedule_get_app, httpRequesthandler);
    }

    public saveEmails(data: any, httpRequesthandler: HttpRequestHandler): void {
        httpRequesthandler.headers = HEADERS;
        this.httpService.post(TaskSchedulerService.ENV.environment.API.schedule_create_email, data, httpRequesthandler);
    }

    public deleteEmails( data: any, httpRequesthandler: HttpRequestHandler): void {
        httpRequesthandler.headers = HEADERS;
        const url = encodeURI(`${TaskSchedulerService.ENV.environment.API.schedule_remove_email}`);
        this.httpService.post(url, data, httpRequesthandler);
    }

}


// WEBPACK FOOTER //
// ./src/app/core/services/task-scheduler/task-scheduler.service.ts